import React, { useState } from "react";
import GoogleMapReact from "google-map-react";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../components/BreadCrumb";

const Marker = ({ lat, lng }) => {
  const [isHovered, setIsHovered] = useState(false);

  const isValidCoordinate =
    !isNaN(lat) &&
    lat >= -90 &&
    lat <= 90 &&
    !isNaN(lng) &&
    lng >= -180 &&
    lng <= 180;

  if (!isValidCoordinate) {
    return (
      <div style={{ color: "red", fontWeight: "bold" }}>
        ⚠️ Invalid coordinates
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: "relative",
        transform: "translate(-50%, -50%)",
        cursor: "pointer",
        zIndex: 1,
      }}
    >
      {/* Custom SVG Marker */}
      <svg
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="red"
        stroke="#fff"
        strokeWidth="2"
      >
        <path d="M12 0C7.31 0 3.5 3.81 3.5 8.5c0 4.69 7.5 15.5 8.5 15.5s8.5-10.81 8.5-15.5c0-4.69-3.81-8.5-8.5-8.5zm0 13c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
      </svg>

      {isHovered && (
        <div
          style={{
            position: "absolute",
            bottom: "40px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white",
            padding: "8px 12px",
            borderRadius: "4px",
            fontSize: "14px",
            whiteSpace: "nowrap",
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          }}
        >
          Lat: {lat}, Lng: {lng}
        </div>
      )}
    </div>
  );
};

const LocationView = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  const location = useLocation();
  const { id } = useParams();

  // const { coordinates, rowData } = location.state || {};
  const query = new URLSearchParams(location.search).get("data");
  const { coordinates, rowData } = query
    ? JSON.parse(decodeURIComponent(query))
    : null;
  // console.log("state", state);

  if (!apiKey) return <div>Loading map...</div>;

  // Convert to numbers and validate
  const lat = Number(coordinates?.lat);
  const lng = Number(coordinates?.lng);

  const secondaryPaths = [
    {
      name: "Customer",
      url: `/dashboard/customers`,
    },

    {
      name: rowData?.companyName || rowData?.email,
      url: `/dashboard/customer/${rowData.id}/manage`,
      state: { ...rowData },
    },
    {
      name: "Auto Event",
      url: "",
    },
  ];

  const isValidCoords =
    !isNaN(lat) &&
    lat >= -90 &&
    lat <= 90 &&
    !isNaN(lng) &&
    lng >= -180 &&
    lng <= 180;

  return (
    <>
      <div
        className="edit-location-zone-map-section"
        style={{
          padding: "20px",
        }}
      >
        <div
          style={{
            height: "900px",
            width: "100%",
            // marginTop: 150,
            // position: "fixed",
            // top: 50,
            // left: 0,
            zIndex: 1,
            // padding: "30px",
          }}
        >
          <GoogleMapReact
            key={`map-${lat}-${lng}`}
            bootstrapURLKeys={{ key: apiKey }}
            center={{ lat, lng }}
            zoom={13}
            options={{
              fullscreenControl: true,
              streetViewControl: false,
              mapTypeControl: true,
              styles: [
                {
                  featureType: "poi",
                  elementType: "labels",
                  stylers: [{ visibility: "on" }],
                },
              ],
            }}
          >
            {isValidCoords && <Marker lat={lat} lng={lng} />}
          </GoogleMapReact>
        </div>
      </div>
    </>
  );
};

export default LocationView;
